{
  "YOUR_FEEDBACK_SUGGESTION_HELP_IMPROVE_PRODUCT": "Uw feedback en suggesties helpen ons onze producten en diensten te verbeteren.",
  "TECHNICAL_ISSUES_CONTACT_ADMIN_OR_SP": "Als u een technisch probleem of ondersteuningsvraag heeft, of onmiddellijke hulp nodig heeft, neem dan contact op met uw Laserfiche-beheerder of Solution Provider zoals aangegeven in uw serviceovereenkomst.",
  "FOUND_SOMETHING_LIKE_DISLIKE_LET_US_KNOW": "Iets gevonden dat u leuk of niet leuk vindt? Laat het ons weten.",
  "DO_YOU_HAVE_IDEA_NEW_FEATURE_IMPROVEMENT_LOOK_FORWARD_TO_HEARING": "Heeft u een idee voor een nieuwe functie of een verbetering? We horen er graag over.",
  "PLEASE_DO_NOT_INCLUDE_CONFIDENTIAL_OR_PERSONAL_INFO_IN_FEEDBACK": "Gelieve geen vertrouwelijke of persoonlijke informatie in uw feedback op te nemen",
  "TELL_US_ABOUT_EXPERIENCE": "Vertel ons over uw ervaring",
  "TELL_US_ABOUT_IDEA": "Vertel ons over uw idee",
  "I_HAVE_FEEDBACK": "Ik heb feedback",
  "I_HAVE_SUGGESTION": "Ik heb een suggestie",
  "YOU_MAY_CONTACT_ME_ABOUT_FEEDBACK": "U mag contact met mij opnemen over deze feedback",
  "IF_YOUD_LIKE_TO_JOIN_OUR_CUSTOMER_PANEL": "Als u lid wilt worden van ons Klantenpanel,",
  "PLEASE_CLICK_HERE": "klik dan hier.",
  "IMAGE_EXCEEDS_MAX_FILE_SIZE_0": "De afbeelding overschrijdt de maximale bestandsgrootte van {0}.",
  "IMAGE_CORRUPTED_UNRECOGNIZED_FORMAT": "De afbeelding is beschadigd of in een niet-herkend formaat.",
  "ACCEPTED_FORMATS_ARE_0": "De geaccepteerde formaten zijn: {0}.",
  "IMAGE_NOT_ATTACHED": "Afbeelding niet toegevoegd.",
  "ATTACH_IMAGE": "Afbeelding bijvoegen",
  "PLEASE_ATTACH_ONLY_ONE_IMAGE": "Voeg alstublieft slechts één afbeelding toe.",
  "TAGS": "Tags",
  "ADD_TAGS": "Tags toevoegen",
  "ADD_MORE_TAGS": "Voeg meer tags toe",
  "NO_TAGS_AVAILABLE": "Geen tags beschikbaar"
}
